import React, { useContext } from 'react';
import { Setting } from '@/components/Setting/Setting';
import { smartPacsAuthContext } from '@/SmartPacsProvider/SmartPacsAuthProvider';

export const SettingPage = () => {
  const { settingMainViewModel } = useContext(smartPacsAuthContext);
  return <Setting settingMainViewModel={settingMainViewModel} />;
};
